import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || '';

const DESPACHOS_COMUNS = [
  { codigo: 'IPAS029', nome: 'Deferimento' },
  { codigo: 'IPAS158', nome: 'Concessão de registro' },
  { codigo: 'IPAS160', nome: 'Prorrogação de registro' },
  { codigo: 'IPAS031', nome: 'Concessão após recurso' },
  { codigo: 'IPAS024', nome: 'Indeferimento' },
  { codigo: 'IPAS099', nome: 'Arquivamento' },
  { codigo: 'IPAS135', nome: 'Caducidade' },
  { codigo: 'IPAS136', nome: 'Nulidade' },
  { codigo: 'IPAS072', nome: 'Extinção' },
  { codigo: 'IPAS039', nome: 'Publicação de pedido' },
  { codigo: 'IPAS009', nome: 'Publicado para oposição' },
];

const UFS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];
const CLASSES_NCL = Array.from({ length: 45 }, (_, i) => String(i + 1).padStart(2, '0'));
const APRESENTACOES = ['Nominativa', 'Mista', 'Figurativa', 'Tridimensional'];
const NATUREZAS = ['Produtos e/ou Serviços', 'Coletiva', 'Certificação'];
const SITUACOES = ['Em andamento', 'Ativa', 'Inativa'];

const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 11, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };
const th = { padding: '5px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em', background: '#0a1628', whiteSpace: 'nowrap' };
const td = { padding: '5px 10px', fontSize: 12, verticalAlign: 'top', borderBottom: '1px solid #e8eaed' };
const tagClasse = { display: 'inline-block', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 10, padding: '1px 6px', fontSize: 10, fontWeight: 700 };
const btnPag = { padding: '3px 8px', borderRadius: 4, border: '1px solid #c8d0da', background: '#fff', color: '#374151', cursor: 'pointer', fontSize: 12 };

export default function ConsultarRpi() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const [rpis, setRpis] = useState([]);
  const [rpiSel, setRpiSel] = useState('');
  const [procurador, setProcurador] = useState('');
  const [titular, setTitular] = useState('');
  const [nomeMarca, setNomeMarca] = useState('');
  const [uf, setUf] = useState('');
  const [apresentacao, setApresentacao] = useState('');
  const [natureza, setNatureza] = useState('');
  const [situacao, setSituacao] = useState('');
  const [despachoCodigo, setDespachoCodigo] = useState([]);
  const [despachoNome, setDespachoNome] = useState('');
  const [classes, setClasses] = useState([]);
  const [depositoDe, setDepositoDe] = useState('');
  const [depositoAte, setDepositoAte] = useState('');
  const [concessaoDe, setConcessaoDe] = useState('');
  const [concessaoAte, setConcessaoAte] = useState('');
  const [vigenciaDe, setVigenciaDe] = useState('');
  const [vigenciaAte, setVigenciaAte] = useState('');
  const [resultado, setResultado] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [ordenacao, setOrdenacao] = useState('nome_asc');
  const [buscaTabela, setBuscaTabela] = useState('');
  const [expandido, setExpandido] = useState(null);

  const POR_PAGINA = 50;

  useEffect(() => {
    fetch(`${API}/marcas-rpi/stats`, { headers })
      .then(r => r.json())
      .then(d => { setRpis(d.rpis || []); if (d.rpis?.length > 0) setRpiSel(d.rpis[0].numero); })
      .catch(() => {});
  }, []);

  function toggleDespacho(codigo) { setDespachoCodigo(prev => prev.includes(codigo) ? prev.filter(c => c !== codigo) : [...prev, codigo]); }
  function toggleClasse(cl) { setClasses(prev => prev.includes(cl) ? prev.filter(c => c !== cl) : [...prev, cl]); }

  function limparFiltros() {
    setProcurador(''); setTitular(''); setNomeMarca(''); setUf('');
    setApresentacao(''); setNatureza(''); setSituacao('');
    setDespachoCodigo([]); setDespachoNome(''); setClasses([]);
    setDepositoDe(''); setDepositoAte(''); setConcessaoDe(''); setConcessaoAte(''); setVigenciaDe(''); setVigenciaAte('');
    setResultado(null); setErro('');
  }

  async function consultar() {
    if (!rpiSel) return;
    setCarregando(true); setErro(''); setResultado(null); setPaginaAtual(1);
    try {
      const params = new URLSearchParams({ rpi: rpiSel });
      if (procurador) params.set('procurador', procurador);
      if (titular) params.set('titular', titular);
      if (nomeMarca) params.set('nome_marca', nomeMarca);
      if (uf) params.set('uf', uf);
      if (apresentacao) params.set('apresentacao', apresentacao);
      if (natureza) params.set('natureza', natureza);
      if (situacao) params.set('situacao', situacao);
      if (despachoCodigo.length) params.set('despacho_codigo', despachoCodigo.join(','));
      if (despachoNome) params.set('despacho_nome', despachoNome);
      if (classes.length) params.set('classe', classes.join(','));
      if (depositoDe) params.set('deposito_de', depositoDe);
      if (depositoAte) params.set('deposito_ate', depositoAte);
      if (concessaoDe) params.set('concessao_de', concessaoDe);
      if (concessaoAte) params.set('concessao_ate', concessaoAte);
      if (vigenciaDe) params.set('vigencia_de', vigenciaDe);
      if (vigenciaAte) params.set('vigencia_ate', vigenciaAte);
      const r = await fetch(`${API}/marcas-rpi/consultar?${params}`, { headers });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Erro na consulta');
      setResultado(d);
    } catch (e) { setErro(e.message); }
    finally { setCarregando(false); }
  }

  const itens = (resultado?.resultados || []).filter(r => {
    if (!buscaTabela) return true;
    const q = buscaTabela.toLowerCase();
    return (r.nome_marca || '').toLowerCase().includes(q) || (r.titular || '').toLowerCase().includes(q) || (r.numero || '').includes(q) || (r.procurador || '').toLowerCase().includes(q);
  }).sort((a, b) => {
    if (ordenacao === 'nome_asc') return (a.nome_marca || '').localeCompare(b.nome_marca || '');
    if (ordenacao === 'nome_desc') return (b.nome_marca || '').localeCompare(a.nome_marca || '');
    if (ordenacao === 'numero_asc') return (a.numero || '').localeCompare(b.numero || '');
    if (ordenacao === 'numero_desc') return (b.numero || '').localeCompare(a.numero || '');
    if (ordenacao === 'titular_asc') return (a.titular || '').localeCompare(b.titular || '');
    if (ordenacao === 'deposito_desc') return (b.data_deposito || '').localeCompare(a.data_deposito || '');
    return 0;
  });

  const totalPaginas = Math.ceil(itens.length / POR_PAGINA);
  const itensPagina = itens.slice((paginaAtual - 1) * POR_PAGINA, paginaAtual * POR_PAGINA);
  const situacaoCor = { 'Ativa': '#16a34a', 'Inativa': '#dc2626', 'Em andamento': '#d97706' };
  const situacaoBg  = { 'Ativa': '#f0fdf4', 'Inativa': '#fef2f2', 'Em andamento': '#fffbeb' };
  const temFiltro = procurador || titular || nomeMarca || uf || apresentacao || natureza || situacao || despachoCodigo.length || despachoNome || classes.length || depositoDe || depositoAte || concessaoDe || concessaoAte || vigenciaDe || vigenciaAte;

  return (
    <div style={{ maxWidth: 1100 }}>
      <div style={{ marginBottom: 12 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Consultar RPI</h1>
        <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>Selecione uma RPI importada e filtre os processos por qualquer critério.</p>
      </div>

      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: '10px 14px', marginBottom: 10 }}>
        {/* RPI + Consultar */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginBottom: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <label style={lbl}>RPI</label>
            <select value={rpiSel} onChange={e => setRpiSel(e.target.value)} style={inp}>
              {rpis.length === 0 && <option value="">Nenhuma RPI importada</option>}
              {rpis.map(r => <option key={r.numero} value={r.numero}>RPI {r.numero} — {r.data}</option>)}
            </select>
          </div>
          <button onClick={consultar} disabled={!rpiSel || carregando} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', border: 'none', borderRadius: 4, fontSize: 12, fontWeight: 700, cursor: 'pointer', height: 26 }}>
            {carregando ? 'Consultando...' : 'Consultar'}
          </button>
          {temFiltro && <button onClick={limparFiltros} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 12, padding: '4px 12px', cursor: 'pointer', height: 26 }}>Limpar filtros</button>}
        </div>

        <div style={{ borderTop: '1px solid #e8eaed', paddingTop: 10 }}>
          <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 11, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 10 }}>Filtros</div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 8, marginBottom: 8 }}>
            <div><label style={lbl}>Procurador</label><input value={procurador} onChange={e => setProcurador(e.target.value)} placeholder="Nome do procurador..." style={inp} onKeyDown={e => e.key === 'Enter' && consultar()} /></div>
            <div><label style={lbl}>Titular</label><input value={titular} onChange={e => setTitular(e.target.value)} placeholder="Nome ou razão social..." style={inp} onKeyDown={e => e.key === 'Enter' && consultar()} /></div>
            <div><label style={lbl}>Nome da marca</label><input value={nomeMarca} onChange={e => setNomeMarca(e.target.value)} placeholder="Busca parcial..." style={inp} onKeyDown={e => e.key === 'Enter' && consultar()} /></div>
            <div><label style={lbl}>UF do titular</label><select value={uf} onChange={e => setUf(e.target.value)} style={inp}><option value="">Todos</option>{UFS.map(u => <option key={u} value={u}>{u}</option>)}</select></div>
            <div><label style={lbl}>Apresentação</label><select value={apresentacao} onChange={e => setApresentacao(e.target.value)} style={inp}><option value="">Todas</option>{APRESENTACOES.map(a => <option key={a} value={a}>{a}</option>)}</select></div>
            <div><label style={lbl}>Natureza</label><select value={natureza} onChange={e => setNatureza(e.target.value)} style={inp}><option value="">Todas</option>{NATUREZAS.map(n => <option key={n} value={n}>{n}</option>)}</select></div>
            <div><label style={lbl}>Situação</label><select value={situacao} onChange={e => setSituacao(e.target.value)} style={inp}><option value="">Todas</option>{SITUACOES.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
            <div><label style={lbl}>Texto do despacho</label><input value={despachoNome} onChange={e => setDespachoNome(e.target.value)} placeholder="Ex: deferimento..." style={inp} onKeyDown={e => e.key === 'Enter' && consultar()} /></div>
          </div>

          <div style={{ marginBottom: 8 }}>
            <label style={lbl}>Despachos (seleção rápida)</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
              {DESPACHOS_COMUNS.map(d => (
                <button key={d.codigo} onClick={() => toggleDespacho(d.codigo)} style={{
                  padding: '2px 8px', borderRadius: 10, fontSize: 11, cursor: 'pointer', fontWeight: 600,
                  background: despachoCodigo.includes(d.codigo) ? '#0a1628' : '#f3f4f6',
                  color: despachoCodigo.includes(d.codigo) ? '#fff' : '#374151',
                  border: `1px solid ${despachoCodigo.includes(d.codigo) ? '#0a1628' : '#c8d0da'}`,
                }}>
                  {d.codigo} — {d.nome}
                </button>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: 8 }}>
            <label style={lbl}>Classes NCL</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
              {CLASSES_NCL.map(cl => (
                <button key={cl} onClick={() => toggleClasse(cl)} style={{
                  width: 34, height: 26, borderRadius: 4, fontSize: 11, cursor: 'pointer', fontWeight: 700,
                  background: classes.includes(cl) ? '#0a1628' : '#f9fafb',
                  color: classes.includes(cl) ? '#fff' : '#374151',
                  border: `1px solid ${classes.includes(cl) ? '#0a1628' : '#c8d0da'}`,
                }}>
                  {cl}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={lbl}>Filtros por data</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 8, marginTop: 4 }}>
              {[
                { label: 'Data de depósito', de: depositoDe, ate: depositoAte, setDe: setDepositoDe, setAte: setDepositoAte },
                { label: 'Data de concessão', de: concessaoDe, ate: concessaoAte, setDe: setConcessaoDe, setAte: setConcessaoAte },
                { label: 'Data de vigência', de: vigenciaDe, ate: vigenciaAte, setDe: setVigenciaDe, setAte: setVigenciaAte },
              ].map(({ label, de, ate, setDe, setAte }) => (
                <div key={label} style={{ background: '#f9fafb', borderRadius: 3, padding: '6px 10px', border: '1px solid #e8eaed' }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', marginBottom: 5, textTransform: 'uppercase' }}>{label}</div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <input type="date" value={de} onChange={e => setDe(e.target.value)} style={{ ...inp, flex: 1 }} />
                    <span style={{ color: '#9ca3af', fontSize: 11 }}>até</span>
                    <input type="date" value={ate} onChange={e => setAte(e.target.value)} style={{ ...inp, flex: 1 }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {erro && <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 4, padding: '8px 12px', color: '#dc2626', marginBottom: 10, fontSize: 12 }}>{erro}</div>}

      {resultado && (
        <>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
            <div style={{ background: '#0a1628', color: '#fff', borderRadius: 4, padding: '4px 12px', fontWeight: 700, fontSize: 12 }}>
              {resultado.total} processo(s) encontrado(s)
            </div>
            <input placeholder="Buscar na tabela..." value={buscaTabela} onChange={e => { setBuscaTabela(e.target.value); setPaginaAtual(1); }}
              style={{ ...inp, width: 200 }} />
            <select value={ordenacao} onChange={e => { setOrdenacao(e.target.value); setPaginaAtual(1); }} style={{ ...inp, width: 'auto' }}>
              <option value="nome_asc">Nome A→Z</option>
              <option value="nome_desc">Nome Z→A</option>
              <option value="numero_asc">Número ↑</option>
              <option value="numero_desc">Número ↓</option>
              <option value="titular_asc">Titular A→Z</option>
              <option value="deposito_desc">Depósito mais recente</option>
            </select>
            {buscaTabela && <span style={{ fontSize: 12, color: '#6b7280' }}>{itens.length} após filtro</span>}
          </div>

          {resultado.total === 0 ? (
            <div style={{ background: '#f9fafb', border: '1px solid #c8d0da', borderRadius: 4, padding: 20, textAlign: 'center', color: '#6b7280', fontSize: 13 }}>
              Nenhum processo encontrado com os filtros aplicados.
            </div>
          ) : (
            <>
              <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                  <thead>
                    <tr>
                      <th style={th}>Nº Processo</th>
                      <th style={th}>Marca</th>
                      <th style={th}>Apresentação</th>
                      <th style={th}>Titular / UF</th>
                      <th style={th}>Procurador</th>
                      <th style={th}>Classes</th>
                      <th style={th}>Despacho(s)</th>
                      <th style={th}>Situação</th>
                      <th style={th}>Depósito</th>
                      <th style={th}>Vigência</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itensPagina.map((r, i) => {
                      const aberto = expandido === r.numero;
                      return (
                        <React.Fragment key={r.numero}>
                          <tr
                            onClick={() => setExpandido(aberto ? null : r.numero)}
                            style={{ background: i % 2 === 0 ? '#fff' : '#fafafa', cursor: 'pointer' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                            onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafafa'}
                          >
                            <td style={{ ...td, fontFamily: 'monospace', fontSize: 11 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {r.numero}
                                <button
                                  onClick={e => { e.stopPropagation(); navigator.clipboard?.writeText(r.numero).catch(() => { const el = document.createElement('textarea'); el.value = r.numero; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); }); }}
                                  title="Copiar número"
                                  style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 4px', fontSize: 10, cursor: 'pointer', color: '#374151', lineHeight: 1, flexShrink: 0 }}>
                                  📋
                                </button>
                              </div>
                            </td>
                            <td style={{ ...td, fontWeight: 600, maxWidth: 140 }}>{r.nome_marca || <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>{r.apresentacao || '—'}</span>}</td>
                            <td style={{ ...td, fontSize: 11 }}>{r.apresentacao || '—'}</td>
                            <td style={{ ...td, maxWidth: 140 }}>
                              <div>{r.titular || '—'}</div>
                              {r.uf && <span style={{ fontSize: 10, color: '#9ca3af' }}>{r.uf}</span>}
                            </td>
                            <td style={{ ...td, fontSize: 11 }}>{r.procurador || <span style={{ color: '#d1d5db' }}>—</span>}</td>
                            <td style={td}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                {(r.classes || []).map(c => <span key={c.codigo} style={tagClasse}>{c.codigo}</span>)}
                              </div>
                            </td>
                            <td style={{ ...td, maxWidth: 160 }}>
                              {(r.despachos || []).map((d, di) => (
                                <div key={di} style={{ fontSize: 10, marginBottom: 1 }}>
                                  <span style={{ fontWeight: 700, color: '#0a1628' }}>{d.codigo}</span>
                                  <span style={{ color: '#6b7280' }}> — {d.nome}</span>
                                </div>
                              ))}
                            </td>
                            <td style={td}>
                              <span style={{ background: situacaoBg[r.situacao] || '#f3f4f6', color: situacaoCor[r.situacao] || '#374151', padding: '1px 7px', borderRadius: 10, fontSize: 10, fontWeight: 700 }}>
                                {r.situacao}
                              </span>
                            </td>
                            <td style={{ ...td, fontSize: 11 }}>{r.data_deposito || '—'}</td>
                            <td style={{ ...td, fontSize: 11 }}>{r.data_vigencia || '—'}</td>
                          </tr>
                          {aberto && (
                            <tr style={{ background: '#f8faff' }}>
                              <td colSpan={10} style={{ padding: '10px 14px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 10, marginBottom: 10 }}>
                                  {[['Número', r.numero], ['Apresentação', r.apresentacao], ['Natureza', r.natureza], ['Depósito', r.data_deposito], ['Concessão', r.data_concessao], ['Vigência', r.data_vigencia], ['RPI', `Nº ${r.rpi_numero} — ${r.rpi_data}`]].map(([label, value]) => (
                                    <div key={label}>
                                      <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 1 }}>{label}</div>
                                      <div style={{ fontSize: 12, color: '#0a1628', fontWeight: 500 }}>{value || '—'}</div>
                                    </div>
                                  ))}
                                </div>
                                {(r.despachos || []).filter(d => d.texto).length > 0 && (
                                  <div style={{ marginBottom: 8 }}>
                                    <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4 }}>Textos dos despachos</div>
                                    {(r.despachos || []).filter(d => d.texto).map((d, di) => (
                                      <div key={di} style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 3, padding: '5px 8px', marginBottom: 4, fontSize: 11, lineHeight: 1.5 }}>
                                        <span style={{ fontWeight: 700, color: '#0a1628' }}>{d.codigo} — {d.nome}: </span>
                                        <span style={{ color: '#374151' }}>{d.texto}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {(r.classes || []).length > 0 && (
                                  <div>
                                    <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4 }}>Especificações de classe</div>
                                    {r.classes.map(c => (
                                      <div key={c.codigo} style={{ fontSize: 11, marginBottom: 3 }}>
                                        <span style={{ ...tagClasse, marginRight: 5 }}>NCL {c.codigo}</span>
                                        <span style={{ color: '#374151' }}>{c.especificacao || '—'}</span>
                                        {c.status && <span style={{ color: '#9ca3af', marginLeft: 4 }}>({c.status})</span>}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {totalPaginas > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: 4, marginTop: 12, alignItems: 'center' }}>
                  <button onClick={() => setPaginaAtual(1)} disabled={paginaAtual === 1} style={btnPag}>«</button>
                  <button onClick={() => setPaginaAtual(p => Math.max(1, p - 1))} disabled={paginaAtual === 1} style={btnPag}>‹</button>
                  {Array.from({ length: Math.min(7, totalPaginas) }, (_, i) => {
                    let pg;
                    if (totalPaginas <= 7) pg = i + 1;
                    else if (paginaAtual <= 4) pg = i + 1;
                    else if (paginaAtual >= totalPaginas - 3) pg = totalPaginas - 6 + i;
                    else pg = paginaAtual - 3 + i;
                    return (
                      <button key={pg} onClick={() => setPaginaAtual(pg)} style={{ ...btnPag, background: pg === paginaAtual ? '#0a1628' : '#fff', color: pg === paginaAtual ? '#fff' : '#374151', fontWeight: pg === paginaAtual ? 700 : 400 }}>{pg}</button>
                    );
                  })}
                  <button onClick={() => setPaginaAtual(p => Math.min(totalPaginas, p + 1))} disabled={paginaAtual === totalPaginas} style={btnPag}>›</button>
                  <button onClick={() => setPaginaAtual(totalPaginas)} disabled={paginaAtual === totalPaginas} style={btnPag}>»</button>
                  <span style={{ fontSize: 11, color: '#9ca3af', marginLeft: 6 }}>Página {paginaAtual} de {totalPaginas}</span>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
